module.exports = __webpack_public_path__ + "img/icon1.ee9860a6.svg";